var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 20,
    rx: 2,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8836 6.46304L18.2797 13.5556H16.3406L17.9446 6.46304H19.8836ZM28.0425 11.0428L29.0635 8.37944L29.6511 11.0428H28.0425ZM30.2062 13.5556H32L30.4348 6.46304H28.7789C28.407 6.46304 28.093 6.66784 27.9534 6.98344L25.044 13.5556H27.0802L27.4847 12.4965H29.9727L30.2062 13.5556ZM25.1451 11.2399C25.1533 9.36795 22.4087 9.26485 22.4278 8.42855C22.4334 8.17405 22.6898 7.90354 23.2501 7.83424C23.5284 7.79994 24.2937 7.77354 25.1626 8.15184L25.5028 6.64785C25.0362 6.48745 24.4356 6.33334 23.6888 6.33334C21.7721 6.33334 20.4228 7.29755 20.4114 8.67815C20.3993 9.69905 21.3744 10.2686 22.1094 10.6081C22.8648 10.9559 23.1187 11.1785 23.1154 11.4894C23.1104 11.9656 22.5127 12.1753 21.9551 12.1836C20.9799 12.1982 20.4141 11.9346 19.963 11.7357L19.6116 13.2897C20.0647 13.4867 20.9009 13.6578 21.7686 13.6666C23.8056 13.6666 25.1384 12.7142 25.1451 11.2399ZM17.1124 6.46304L13.9704 13.5556H11.9202L10.3742 7.89524C10.2802 7.54654 10.1987 7.41904 9.913 7.27214C9.4474 7.03294 8.6774 6.80834 8 6.66904L8.0463 6.46304H11.346C11.7666 6.46304 12.1449 6.72785 12.2403 7.18605L13.057 11.2906L15.0751 6.46304H17.1124Z",
    fill: "#122133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6d6a42c35c639567b44eb47a8c707c4c.svg";
export { ForwardRef as ReactComponent };